import { captureException } from '@sentry/nextjs';
import { TAppEnvironmentSettings } from '../environment/environment.types';
import { getAppEnvironmentSettings } from '../environment/environment';
import { TUser } from '../configuration/common.types';

const headers = {
    'AzureAuthentication': '1',
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    'Cache': 'no-cache',
    'X-Requested-With': 'XMLHttpRequest',
};

const environment: Readonly<TAppEnvironmentSettings & TAppEnvironmentSettings> =
    getAppEnvironmentSettings();

export const getUser = async () => {
    const response = await fetch(
        `${environment.baseApiUrl}/users-api/v1/user/getuserdetails`,
        {
            headers,
            method: 'GET',
            credentials: 'include',
            mode: 'cors',
        }
    );

    if (!response.ok) {
        const errorMessage = 'Could not get user data.';
        captureException(errorMessage, {
            extra: {
                response,
            },
        });
        throw new Error(errorMessage);
    }

    const user: TUser = await response.json();
    return user;
};
